import { request } from '../../utils/request';
import { haloRequest } from '../../utils/haloRequest';
import { pandoraRequest } from '../../utils/pandoraRequest';
import axios from 'axios';

export async function getAvatarDetail(id) {
  return axios({
    url: process.env.VUE_APP_AVATAR_TOKEN_URL + '/' + id + '.json',
    method: 'get',
  })
}

export function getNftList(params) {
  return haloRequest({
    url: '/nft/nfts_online_paged',
    method: 'get',
    params: {
      ...params
    },
    headers: {
      Authorization: sessionStorage.getItem('superAvatarAuthToken')
    },
  })
}

export function getNftDetail(params) {
  return haloRequest({
    url: '/nft/my_nft',
    method: 'get',
    params: {
      ...params
    },
    headers: {
      Authorization: sessionStorage.getItem('superAvatarAuthToken')
    },
  })
}

export function getRefreshNftId(params) {
  return haloRequest({
    url: '/nft/freshStakeNftId',
    method: 'get',
    params: {
      ...params
    },
    headers: {
      Authorization: sessionStorage.getItem('superAvatarAuthToken')
    },
  })
}